import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import moment from "moment";
import { getWallet, getWalletHistory } from "../../../services/wallet.service";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

export default function WalletHistory() {
  const [isLoading2, setIsLoading2] = useState(false);
  const { token } = useSelector((state) => state?.auth);
  const [retailerWallet, setRetailerWallet] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const retailerId = params.get("id");

  const [retailerData, setRetailerData] = useState(null);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [selectedTab, setSelectedTab] = useState("total"); // State for selected tab
  const [isLoading, setIsLoading] = useState(true);

  const fetchWallet = async () => {
    try {
      const res = await getWalletHistory(token, retailerId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setRetailerWallet(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.error ||
            "Failed to fetch wallet details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching wallet details:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error ||
          "An error occurred while fetching the wallet. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (retailerId) {
      fetchWallet();
    }
  }, [retailerId]);

  const filterTransactions = (tab) => {
    if (tab === "total") {
      return retailerWallet?.combined_wallet_history || [];
    }

    if (tab === "used") {
      return retailerWallet?.combined_wallet_history?.filter(
        (item) =>
          item.transaction_type === "reduced" ||
          item.transaction_type === "paid"
      );
    }

    if (tab === "remaining") {
      return retailerWallet?.combined_wallet_history?.filter(
        (item) =>
          item.transaction_type === "reduced" ||
          item.transaction_type === "paid"
      );
    }

    if (tab === "received") {
      return retailerWallet?.combined_wallet_history?.filter(
        (item) => item.transaction_type === "add"
      );
    }

    return [];
  };

  const handleCardClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title d-flex">
                  Wallet History{" "}
                  <h5 className="mt-1 ms-3">
                    (Retailer: {retailerWallet?.retailer_name})
                  </h5>
                </h4>
                <Link to="/retailer/credit-wallet">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body">
                {/* Retailer Summary */}
                <div className="row mb-4">
                  <div
                    className="col-md-3"
                    onClick={() => handleCardClick("total")}
                  >
                    <div className="card border-primary">
                      <div className="card-body text-center">
                        <h5>Total Tansactions</h5>
                        <h3 className="text-info">
                          {retailerWallet?.combined_wallet_history?.length}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-3"
                    onClick={() => handleCardClick("used")}
                  >
                    <div className="card border-success">
                      <div className="card-body text-center">
                        <h5>Used Credits</h5>
                        <h3 className="text-warning">
                          {(retailerWallet?.credits_used * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-3"
                    onClick={() => handleCardClick("remaining")}
                  >
                    <div className="card border-warning">
                      <div className="card-body text-center">
                        <h5>Remaining Credits</h5>
                        <h3 className="text-primary">
                          {(retailerWallet?.remaining_credits * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-3"
                    onClick={() => handleCardClick("received")}
                  >
                    <div className="card border-info">
                      <div className="card-body text-center">
                        <h5>Received Credits</h5>
                        <h3 className="text-success">
                          {(retailerWallet?.received_credits * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                {filterTransactions(selectedTab)?.length > 0 && (
                  <div className="table-responsive">
                    <h5 className="mb-3">
                      {selectedTab.charAt(0).toUpperCase() +
                        selectedTab.slice(1)}{" "}
                      Transactions
                    </h5>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Credits</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      {/* <tbody>
                      {retailerWallet?.combined_wallet_history?.map(
                        (item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {moment(item.transaction_date).format(
                                "YYYY-MM-DD"
                              )}
                            </td>
                            <td>
                              <span
                                className={`border border-light badge bg-${
                                  item.transaction_type === "add"
                                    ? "btn btn-success light btn-sm"
                                    : item.transaction_type === "reduced"
                                    ? "btn btn-danger light btn-sm"
                                    : "btn btn-warning light btn-sm"
                                }`}
                              >
                                {item.transaction_type === "reduced" ? "DEDUCTED" : item.transaction_type.toUpperCase()}
                              </span>
                            </td>
                            <td>
                              ₹
                              {item?.amount?.toFixed(2) ||
                                (item?.paid_amount * 1)?.toFixed(2)}
                            </td>
                            <td style={{ width: "35%" }}>
                              {item.note || "NA"}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody> */}
                      <tbody>
                        {filterTransactions(selectedTab)?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {moment(item.transaction_date).format(
                                "YYYY-MM-DD"
                              )}
                            </td>
                            <td>
                              <span
                                className={`border border-light badge bg-${
                                  item.transaction_type === "add"
                                    ? "btn btn-success light btn-sm"
                                    : item.transaction_type === "reduced"
                                    ? "btn btn-danger light btn-sm"
                                    : "btn btn-warning light btn-sm"
                                }`}
                              >
                                {item.transaction_type === "reduced"
                                  ? "DEDUCTED"
                                  : item.transaction_type.toUpperCase()}
                              </span>
                            </td>
                            <td>
                              
                              {item?.amount ? (item?.amount * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                ) :
                                (item?.paid_amount * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                            </td>
                            <td style={{ width: "35%" }}>
                              {item.note || "NA"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
